// adventureTravel.js

const adventureTravel = {
  id: 7,
  title: "Adventure Travel",
  questions: [
    {
      question: "Do you offer adventure travel packages?",
      answer:
        "Yes, we offer trekking, camping, rafting, biking, skiing, and other adventure travel experiences.",
    },
    {
      question: "Are adventure trips safe?",
      answer:
        "Safety is our priority, and we work with experienced operators and certified activity partners.",
    },
    {
      question: "Can beginners join adventure trips?",
      answer:
        "Yes, many of our adventure experiences are beginner-friendly and guided professionally.",
    },
  ],
};

export default adventureTravel;